/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../conexiones';
import ITiposDivisiones from './entidades/tiposDivisiones';
import IFiltrosTiposDivisiones from './entidades/filtrosTiposDivisiones';

export default class ModeloTiposDivisiones {
    public consultarTiposDivisiones() {
        return manejadorRest<IRespuesta<ITiposDivisiones>>(() =>
            negocio.get('TipoDivision/ConsultarListaTipoDivision')
        );
    }
    public crearTiposDivisiones(tiposDivisiones: ITiposDivisiones) {
        return manejadorRest<IRespuesta<ITiposDivisiones>>(() =>
            negocio.post('TipoDivision/GuardarTipoDivision', tiposDivisiones)
        );
    }
    public editarTiposDivisiones(tiposDivisiones: ITiposDivisiones) {
        return manejadorRest<IRespuesta<ITiposDivisiones>>(() =>
            negocio.put('TipoDivision/EditarTipoDivision', tiposDivisiones)
        );
    }
    public eliminarTiposDivisiones(tiposDivisiones: ITiposDivisiones) {
        return manejadorRest<IRespuesta<ITiposDivisiones>>(() =>
            negocio.delete('TipoDivision/EliminarTipoDivision', tiposDivisiones)
        );
    }
    public consultarListaTiposDivisionesPorFiltro(filtrosTiposDivisiones: IFiltrosTiposDivisiones) {
        return manejadorRest<IRespuesta<ITiposDivisiones>>(
            () => negocio.post('TipoDivision/ConsultarListaTipoDivisionPorFiltro', filtrosTiposDivisiones),
            true
        );
    }
}
